module.exports = __webpack_public_path__ + "img/svg/step4.ad33176b824add725d1673fe17737c08.svg";